import * as React from 'react';
import { useT } from '../helpers/i18n';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import FooterSkeleton from './Skeletons/FooterSkeleton';
import * as appContext from './AppContext';
import Contact from './Contact';
import Footer from './Footer';
import ViewPort from './ViewPort';
import GoogleMapSection from "./GoogleMapSection";
import Checkers from "../helpers/class/Checkers";
import { BODY_END_WIDGETS_ID, fetchBuilderSettingByKey, uniqueElfsightSections } from "../helpers/MethodHelper";
import NewsletterSection from "./templates/index/sections/NewsletterSection";
import PartnersSection from "./templates/index/sections/PartnersSection";
import { ElfsightWidget } from "react-elfsight-widget";
import { faViber, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp as falArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { usePathname } from "next/dist/client/components/hooks-client";
import { useRouter } from "next/router";

interface BottomSectionsProps {
  contactSection: any
  footerSection: any
  app_data: any
  head: any
  app: any
  locations: any
  footer: any
  isDesktop?: any
  captchaSiteKey?: any
  footerRef?: any
  footerPaddingClass?: string
  htmlSections?: any
  contactHtml?: any
  propertyAllImages?: any
  content?: any
}

export default function BottomSections(props: BottomSectionsProps) {
  const t = useT();

  const contact_section = props.contactSection;

  const contactSeoTitle = props.app.builder.builder_contact_seo_title_cat

  const footer_section = props.footerSection;
  const contactHtml = props.hasOwnProperty('contactHtml') ? props.contactHtml : null

  const router = useRouter()

  const fullPath = router.asPath

  const pathname = fullPath.split(/[?#]/)[0];  // removes ?query and #hash
  const pathWithoutSlash = pathname.startsWith('/') ? pathname.slice(1) : pathname;


  const isMobile = useSelector(state => state['appSettings']['isMobile'])
  const isTablet = useSelector(state => state['appSettings']['isTablet'])

  const app_data = props.app_data;
  const head = props.head;
  const app = props.app;
  const locations = props.locations;
  const footer = props.footer;
  const isDesktop = props.isDesktop;

  const captchaSiteKey = props.captchaSiteKey;

  const contactFormInFooter = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_contact_in_different_page') == 1 ? false : true
  );

  const showChatIconsMobile = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_general_chat_icons_side_show_mobile') == 1 ? true : false
  );

  const showChatIconsDesktop = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_general_chat_icons_side_show_desktop') == 1 ? true : false
  );

  const showChatIconWhatapp = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_general_show_chat_icon_whatsapp')
  );

  const showChatIconViber = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_general_show_chat_icon_viber')
  );

  const enableNewsletter = app.enableNewsletter

  const newsletterAskFirstname = app.newsletterAskFirstname

  const newsletterAskLastname = app.newsletterAskLastname

  const newsletterAskPhone = app.newsletterAskPhone

  const newsletterTitle = app.newsletterTitle

  const newsletterSubtitle = app.newsletterSubtitle

  const newsletterDesc = app.newsletterDesc

  const newsletterBackground = app.newsletterBgColor

  // the builder setting wins; when it was never set, follow the design mode of the site like the Lodge
  const newsletterDarkMode = app.builder.builder_newsletter_dark_mode != null && app.builder.builder_newsletter_dark_mode !== ''
    ? app.builder.builder_newsletter_dark_mode
    : (app.designMode === true || app.designMode === '1' || app.designMode === 1 ? '1' : '0')

  const htmlSections = props.htmlSections != null && props.htmlSections.hasOwnProperty('app_sections') ? props.htmlSections.app_sections : null

  // same choice as the Lodge (newsletter.html.twig): the newsletter image of the site, otherwise the first image
  // of the page for multi-property sites, or the first image of the property for a single property
  const newsletterBackgroundHandler = () => {
    if (Checkers.isValidString(props.app.newsletterImage)) {
      return props.app.newsletterImage;
    }

    // single property site: the API sends the first featured photo of the property (same rule as the Lodge), on every page
    if (Checkers.isValidString(props.app.newsletterPropertyImage)) {
      return props.app.newsletterPropertyImage;
    }

    const firstImage = (images) => Checkers.isValidArray(images) && Checkers.isValidString(images[0]?.image) ? images[0].image : null

    const isSingleProperty = Checkers.isValidNumber(props.content?.property_id) && !Checkers.valueToBoolean(props.content?.is_chain)
    const propertyImages = props.content?.albumIsPageAlbum === false ? props.content?.album : null

    if (isSingleProperty) {
      // the Lodge uses the first featured image of the property (sorted), which is the first of propertyAllImages
      return firstImage(props.propertyAllImages) ?? firstImage(propertyImages) ?? firstImage(props.app.pageMedia)
    }

    return firstImage(props.app.pageMedia) ?? firstImage(propertyImages)
  }

  const contactBlock = (
    contactFormInFooter ?
      <>
        {
          fullPath !== "/contact/success" &&
            fullPath !== "/contact" &&
            (!contactSeoTitle || pathWithoutSlash !== contactSeoTitle) &&
            contact_section ?
            <Contact
              isDesktop={isDesktop}
              contactFormTitle={app.contactFormTitle}
              locations={locations != null ? locations.hasOwnProperty('page_locations') ? locations.page_locations : null : null}
              captchaSiteKey={captchaSiteKey}
              showContactSection={app.showContactSection}
              showContactForm={app.showContactForm}
              showName={app.contactAskName}
              showEmail={app.contactAskEmail}
              showPhone={app.contactAskPhone}
              showDates={app.contactAskDates}
              showDestination={app.contactAskDestination}
              searchbarRadius={app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius.length : null : null}
              contactPhoneOverride={app.builder.builder_contact_page_phone}
              contactEmailOverride={app.builder.builder_contact_page_email}
              contactTitleOverride={
                Checkers.isValidString(app.builder.builder_contact_page_title)
                  ? app.builder.builder_contact_page_title
                  : ( !props.app_data?.is_manager && Checkers.isValidString( props.content?.details?.title ) ? props.content.details.title : null )
              }
              contactHtml={contactHtml}
              isManager={props.app_data?.is_manager}
              socialLinks={props.content?.socialLinks}
              managerContact={props.content?.managerContact}
              propertyLat={props.content?.details?.lat}
              propertyLng={props.content?.details?.lng}
              propertyBadges={props.content?.propertyBadges}
              contactEmails={app.contactEmails}
            />
            : <></>
        }
      </>
      :
      <></>
  );

  const newsletterBlock = (
    enableNewsletter ?
        <></>
      // <NewsletterSection
      //   newsletterAskFirstname={newsletterAskFirstname}
      //   newsletterAskLastname={newsletterAskLastname}
      //   newsletterAskPhone={newsletterAskPhone}
      //   title={newsletterTitle}
      //   subtitle={newsletterSubtitle}
      //   description={newsletterDesc}
      //   newsletterBgImage={newsletterBackgroundHandler()}
      //   newsletterBackground={newsletterBackground}
      //   darkMode={newsletterDarkMode}
      // />
      :
      <></>
  );

  const footerCtaSections = !props.app_data?.is_manager
    ? <>{contactBlock}{newsletterBlock}</>
    : <>{newsletterBlock}{contactBlock}</>;

  return (
    <>

      {
        ((Checkers.valueToBoolean(isMobile) && showChatIconsMobile) || (Checkers.valueToBoolean(isDesktop) && showChatIconsDesktop)) ?
          <>
            {
              (Checkers.isValidString(showChatIconViber) || Checkers.isValidString(showChatIconWhatapp)) ?
                <>
                  <div className={'chat-icons'}>
                    {
                      Checkers.isValidString(showChatIconViber) ?
                        <>
                          <a className={'icon viber'} href={showChatIconViber} target={'_blank'} rel="noreferrer">
                            <FontAwesomeIcon icon={faViber} className="" size="xl" />
                            {/*<span>*/}
                            {/*  Viber*/}
                            {/*</span>*/}
                          </a>
                        </>
                        :
                        <>
                        </>
                    }
                    {
                      Checkers.isValidString(showChatIconWhatapp) ?
                        <>
                          <a className={'icon whatsapp'} href={showChatIconWhatapp} target={'_blank'} rel="noreferrer">
                            <FontAwesomeIcon icon={faWhatsapp} className="" size="xl" />
                            {/*<span>Whatsapp</span>*/}
                          </a>
                        </>
                        :
                        <>
                        </>
                    }
                  </div>
                </>
                :
                <>
                </>
            }
          </>
          :
          <>
          </>
      }

      {
        fullPath !== "/contact" && fullPath !== "/contact/success" && htmlSections != null && Checkers.isValidArray(htmlSections) ?
          <>
            <div className={'container-fluid overflow-hidden' + (!props.app_data?.is_manager ? ' pb-4' : '')}>
              {
                uniqueElfsightSections(htmlSections).map((section, key) => (
                  section.app_section_content != null ?
                    section.app_section_content.includes('elfsight-app') ?
                      section.app_section_content.split('elfsight-app-')[1] != null ?
                        <ElfsightWidget key={key}
                          widgetID={section.app_section_content.split('elfsight-app-')[1].split('"></div>')[0]} />
                        :
                        <></>
                      :
                      <></>
                    :
                    <></>
                ))
              }
            </div>
          </>
          :
          <></>
      }
      {/* Elfsight widgets of the "end of body" sections are moved here by BodyEndSectionsWrapper, so inline
          widgets (e.g. reviews) sit above the footer like the ones above; popups/chat float either way */}
      <div id={BODY_END_WIDGETS_ID} className={'container-fluid overflow-hidden'}/>
      {fullPath !== "/contact" && fullPath !== "/contact/success" && !props.app_data?.is_manager && <PartnersSection content={props.content}/>}
      {footerCtaSections}
      {
        footer_section ?
          <ViewPort
            ref={props.footerRef}
            parentClass="row w-100 m-0"
            skeletonItem={<FooterSkeleton height={app_data.has_android_app || app_data.has_ios_app ? 250 : 172} />}
          >
            <Footer
              footerPaddingClass={props.footerPaddingClass}
              isDesktop={isDesktop}
              designMode={app.designMode}
              menu={footer.menu}
              footerContent={footer}
              title={!props.app_data?.is_manager && Checkers.isValidString( props.content?.details?.title ) ? props.content.details.title : head.data.hasOwnProperty('titleOfficial') && head.data.titleOfficial != null ? head.data.titleOfficial : head.data.hasOwnProperty('title') ? head.data.title : null}
              fixed={(app.enableBooking && app.bookingSearchbarWidth && !(app.bookingSearchbarPosition))}
              iosApp={app_data.has_ios_app ? app_data.ios_app_link : null}
              androidApp={app_data.has_android_app ? app_data.android_app_link : null}
              iosAppText={app_data.has_ios_app ? app_data.ios_app_text : null}
              androidAppText={app_data.has_android_app ? app_data.android_app_text : null}
              hasLoggiaBadge={app_data.has_loggia_badge}
              loggiaBadgeText={app_data.has_loggia_badge ? app_data.loggia_badge_text : null}
              registrationNumber={!app_data.is_manager ? app_data.registration_number : null}
              hasPrivacyPolicy={Checkers.isValidString(app.privacyPolicy)}
              hasTermsAndConditions={Checkers.isValidString(app.termsAndConditions)}
              registrationNumberText={!app_data.is_manager ? app_data.registration_number_text : null}
              isManager={app_data.is_manager}
              socialLinks={props.content?.socialLinks}
            />
          </ViewPort>
          :
          ''
      }

      {/* <button
        type="button"
        className="btn btn-lg btn-primary btn-design-color rounded-circle shadow-5 z-index-5"
        id="btn-back-to-top"
        aria-label={t('a11y.backToTop')}
      >
        <FontAwesomeIcon className="fs-16" icon={falArrowUp} />
      </button> */}
    </>
  )
}
